import ReactTooltip from 'react-tooltip'
import { useSelector, useDispatch } from 'react-redux'
import { STEP_REVIEW } from '@names'
import _ from '@strings'
import Inner from '@components/Ui/Inner'
import Button from '@components/Ui/Button'
import { useMediaQueryContext, useDsgvoContext } from '@context'
import { next, previous } from '@store/actions/app'
import styles from './Footer.scss'

const Footer = () => {
  const dispatch = useDispatch()
  const { touch } = useMediaQueryContext()
  const { accepted, setHover } = useDsgvoContext()
  const currentStep = useSelector((s) => s.app.step)
  const nextButton = useSelector((s) => s.app.next)
  const previousButton = useSelector((s) => s.app.previous)
  const mode = useSelector((s) => s.data.mode)

  const onClickNext = () => {
    dispatch(next())
  }

  const onClickPrevious = () => {
    dispatch(previous())
  }

  return (
    <Inner className={styles.base} classNameOuter={styles.outer}>
      {nextButton.show && (
        <div
          className={styles.next}
          data-tip={_('review.tooltip')}
          data-for="footer"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Button
            onClick={onClickNext}
            disabled={nextButton.disabled}
            loading={nextButton.loading}
            e2eType="next"
            theme="brand"
          >
            {currentStep === STEP_REVIEW &&
              _(mode === 'live' ? 'general.button_submit' : 'general.button_submit_request')}
            {currentStep !== STEP_REVIEW && _('general.button_next')}
          </Button>
        </div>
      )}
      {previousButton.show && (
        <div className={styles.back}>
          <Button
            onClick={onClickPrevious}
            theme="outline-light"
            disabled={previousButton.disabled}
            e2eType="previous"
          >
            {_('general.button_previous')}
          </Button>
        </div>
      )}
    </Inner>
  )
}
Footer.defaultProps = {}
Footer.propTypes = {}

export default Footer
